import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetCurrentRegionActionType, TSetCurrentRegion } from './types';
import { ICurrentRegion } from '../../../types/geo';

export const setCurrentRegion: (region: ICurrentRegion) => TSetCurrentRegion = actionGenerator<
  ESetCurrentRegionActionType.Set,
  ICurrentRegion
>(ESetCurrentRegionActionType.Set);
